// Shared Material-UI table styles for consistent appearance across the application

export const TABLE_HEADER_STYLE = {
    backgroundColor: '#0487C8',
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '14px',
    fontFamily: 'Karla, sans-serif',
    padding: '8px',
    border: '1px solid #FFFFFF'
};

export const TABLE_CELL_STYLE = {
    fontSize: '14px',
    fontFamily: 'Karla, sans-serif',
    color: '#333333',
    padding: '8px',
    backgroundColor: '#f0f8ff',
    border: '1px solid #d9d9d9'
};

export const TABLE_PAGINATION_STYLE = {
    fontSize: '14px',
    fontFamily: 'Karla, sans-serif',
    color: '#333333'
};

export const TABLE_INPUT_STYLE = {
    fontSize: '14px',
    fontFamily: 'Karla, sans-serif',
    color: '#333333',
    backgroundColor: '#FFFFFF'
};

export const TABLE_SORT_LABEL_STYLE = {
    color: '#FFFFFF',
    fontSize: '14px',
    fontFamily: 'Karla, sans-serif'
};

// Helper function to apply header styles with custom width
export const getHeaderStyle = (width) => ({
    ...TABLE_HEADER_STYLE,
    ...(width && { width })
});

// Helper function to apply cell styles
export const getCellStyle = (customStyles = {}) => ({
    ...TABLE_CELL_STYLE,
    ...customStyles
});